import { useAuth } from 'context/authContext'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { sendConfirmation } from 'services/auth'

interface ISendConfirmationPayload {
    phone_number: string
    code: string
}
const UseSendConfirmation = (
    setIsSubmit: React.Dispatch<React.SetStateAction<boolean>>,
    mobile: string
) => {
    const navigate = useNavigate()
    const { login } = useAuth()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISendConfirmationPayload) => {
            return sendConfirmation(payload)
        },
        onSuccess: (data) => {
            if (data.two_factor_token) {
                navigate('/auth/two-factor', {
                    state: {
                        phone_number: mobile,
                        two_factor_token: data.two_factor_token,
                    },
                })
            } else {
                toast.success('ورود با موفقیت انجام شد')
                login(data)
                navigate('/auth/profile')
            }
        },
        onError: () => {
            toast.error('کد وارد شده صحیح نمی باشد')
            setIsSubmit(false)
        },
    })

    return { isLoading, mutate }
}

export default UseSendConfirmation
